import { Dialog, FormControl, FormControlLabel, RadioGroup, Stack } from "@mui/material";
import React, { useContext, useRef, useState } from "react";
import { saveFeedbackAPI } from "../../../../../api/feedback/saveFeedbackAPI";
import { thumbsDownLightIcon } from "../../../../../constant";
import { Messages } from "../../../../../constant/messages/toastMessages";
import { StateContext } from "../../../../../context/globalContext/context";
import { iGlobalContext } from "../../../../../context/globalContext/interface";
import { toastMessage } from "../../../../../utils/ToastProvider";
import { consoleLog } from "../../../../../utils/consoleLog/consoleLog";
import { CustomRadio } from "../../customRadio/customRadio";
import AppButton from "../../../../reusableComponent/button/button";
import CloseDialogBtn from "../../../../reusableComponent/closeDialogBtn/CloseDialogBtn";
import styles from "./userFeedbackDialog.module.scss";
import { iItineraryDetailsContext } from "../../../../itineraryDetails/itineraryDetailsPage/components/itineraryDetailsContext/itineraryDetailsInterface";
import { useItineraryContext } from "../../../../itineraryDetails/itineraryDetailsPage/components/itineraryDetailsContext/ItineraryDetailsContext";
import { palette, br } from "../../../../../styles/design-tokens";

const FEEBACK_LIST = [
  "Generic Recommendations",
  "Lack of Practical Details",
  "Outdated or Incorrect Information",
  "Lack of Customization",
  "Overwhelming Amount of Information",
  "Poor Understanding of Local Culture or Logistics",
  "Ignoring Travel Constraints",
  "Other",
];

export default function UserFeedbackDialog({
  open,
  onClose,
}: Readonly<{
  open: boolean;
  onClose?: any;
}>) {
  const globalContext = useContext(StateContext);
  const { selectedChatData, accessJWT }: iGlobalContext = globalContext;
  const { saveItineraryBeforeBooking }: iItineraryDetailsContext = useItineraryContext();

  const [disableBtn, setDisableBtn] = useState(false);
  const [value, setValue] = useState("female");
  const [textareaValue, setTextareaValue] = useState("");
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = (event.target as HTMLInputElement).value;
    setValue(selectedValue);
    if (selectedValue === "Other" && textareaRef.current) {
      textareaRef.current.focus();
    }
  };

  async function handleSubmit() {
    setDisableBtn(true);
    const itineraryId = await saveItineraryBeforeBooking(selectedChatData);
    if (!itineraryId) return;
    const response = await saveFeedbackAPI(accessJWT, {
      itineraryId: itineraryId,
      comment: textareaValue ?? "",
      feedBackType: value ?? "",
    });
    consoleLog(["FEEDBACK SUBMITED RESPONSE", response]);
    if (response?.statusCode === 200) {
      toastMessage.success(Messages["feedback.success"].messageTitle, Messages["feedback.success"].message);
      onClose();
      setTextareaValue("");
    } else {
      toastMessage.error(Messages["feedback.failure"].messageTitle, Messages["feedback.failure"].message);
    }
    setDisableBtn(false);
  }

  return (
    <Dialog
      onClose={onClose}
      open={open}
      className={styles.main}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: palette["black-a85"],
          },
        },
      }}
      PaperProps={{
        style: {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      <div className={styles.mainHeaderContainer}>
        <div className={styles.editActivitiesText}>
          <h1>User Feedback</h1>
        </div>
        <Stack alignSelf="end" mb={2} mr={1.4}>
          {/* <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              padding: 0,
              cursor: "pointer",
            }}
          >
            <img style={{ width: "17px" }} src={updatedCloseIcon} alt="cross" />
          </button> */}
          <CloseDialogBtn onClose={onClose} />
        </Stack>
      </div>
      <Stack
        sx={{
          width: "100%",
          maxHeight: {
            sm: "80vh",
            xs: "80vh",
            md: "calc(100% - 5%)",
            lg: "calc(100% - 5%)",
          },
          overflow: "auto",
          bgcolor: palette["gray-97"],
          borderRadius: br(8),
        }}
      >
        {/* Dialog content */}
        <div className={styles.dialogContainer}>
          <div className={styles.headerContainer}>
            <h1>Report Bad Response</h1>
            <img src={thumbsDownLightIcon} alt="thumbs down" />
          </div>
          <div className={styles.detailsContainer}>
            <h1>
              Why was this response <span>unhelpful?</span>
            </h1>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
                value={value}
                onChange={handleChange}
                className={styles.radioGroup}
              >
                {FEEBACK_LIST.map((ele: string) => (
                  <div className={styles.radioContainer} key={ele}>
                    <FormControlLabel
                      value={ele}
                      control={<CustomRadio />}
                      label={<p>{ele}</p>}
                      className={styles.radioLabel}
                    />
                    {ele === "Other" && (
                      <div className={styles.textAreaContainer}>
                        <textarea
                          value={textareaValue}
                          onChange={(e) => setTextareaValue(e.target.value)}
                          ref={textareaRef}
                          className={styles.textArea}
                          rows={6}
                          placeholder="Type feedback here"
                        />
                        <p>160</p>
                      </div>
                    )}
                  </div>
                ))}
              </RadioGroup>
            </FormControl>
          </div>
          <div className={styles.buttonContainer}>
            <AppButton onClick={handleSubmit} disabled={disableBtn}>
              Submit
            </AppButton>
          </div>
        </div>
      </Stack>
    </Dialog>
  );
}
